import { Trans } from '@lingui/react/macro';
import { NoddiIcon } from 'noddi-ui-common';

type Props = {
  carDisplayName: string;
  lines: { name: string; quantity: number }[];
  locationName?: string;
  /** Formatted by the flow, which owns its decimals rule. */
  total: string;
};

/** What the held time is for, in the login step's order row: the car, its services and where. */
export const StationaryLoginOrderDetails = ({ carDisplayName, lines, locationName, total }: Props) => {
  const lineSummary = lines
    .map((line) => (line.quantity === 1 ? line.name : `${line.quantity}x ${line.name}`))
    .join(', ');

  return (
    <div className='flex flex-col gap-3'>
      <div className='flex gap-2'>
        <NoddiIcon name='Car' className='mt-0.5 shrink-0' />
        <div className='flex min-w-0 flex-col'>
          <span className='font-semibold'>{carDisplayName}</span>
          {lineSummary && <span className='text-sm text-muted-foreground'>{lineSummary}</span>}
        </div>
      </div>

      {locationName && (
        <div className='flex gap-2'>
          <NoddiIcon name='MapPin' className='mt-0.5 shrink-0' />
          <div className='flex min-w-0 flex-col'>
            <span className='text-sm text-muted-foreground'>
              <Trans>Service center</Trans>
            </span>
            <span className='font-semibold'>{locationName}</span>
          </div>
        </div>
      )}
      <div className='flex justify-between gap-4 border-t border-border pt-3 font-semibold'>
        <span>
          <Trans>Total sum including VAT</Trans>
        </span>
        <span className='whitespace-nowrap'>{total}</span>
      </div>
    </div>
  );
};
